/* Banner-renderer: samme kode brukes til forhåndsvisning i butikken og til printfilen.
   Alle mål i mm. Tegner SVG for et banner W x H med valgfri bleed og trykkmerker. */
(function (root) {
  const FONTS = {
    playfair: { name: 'Elegant', css: 'BRPlayfair', weight: 700, cap: 0.71 },
    fredoka:  { name: 'Leken',   css: 'BRFredoka',  weight: 600, cap: 0.70 },
    dancing:  { name: 'Håndskrift', css: 'BRDancing', weight: 700, cap: 0.72 },
    creepster: { name: 'Skummel', css: 'BRCreepster', weight: 400, cap: 0.73 },
    playwrite: { name: 'Løkkeskrift', css: 'BRPlaywrite', weight: 400, cap: 0.70 },
    quicksand: { name: 'Ren', css: 'BRQuicksand', weight: 600, cap: 0.70 }
  };

  // enkel deterministisk tilfeldighet (samme konfetti hver gang)
  function rng(seed) { let s = seed >>> 0; return () => ((s = (s * 1664525 + 1013904223) >>> 0) / 4294967296); }
  const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  function balloon(x, y, rx, ry, fill, u) {
    const knotY = y + ry;
    return `<g><path d="M${x} ${knotY} q ${-2*u} ${10*u} ${1.5*u} ${22*u} t ${-1*u} ${20*u}" fill="none" stroke="#9aa0a6" stroke-width="${0.35*u}"/>` +
      `<ellipse cx="${x}" cy="${y}" rx="${rx}" ry="${ry}" fill="${fill}"/>` +
      `<ellipse cx="${x - rx*0.35}" cy="${y - ry*0.4}" rx="${rx*0.18}" ry="${ry*0.28}" fill="#fff" opacity=".45" transform="rotate(-25 ${x - rx*0.35} ${y - ry*0.4})"/>` +
      `<path d="M${x - 1.2*u} ${knotY + 1.4*u} L${x} ${knotY - 0.4*u} L${x + 1.2*u} ${knotY + 1.4*u} Z" fill="${fill}"/></g>`;
  }


  // ---- halloween-elementer (vektor) ----
  function pumpkin(x, y, s, face, glow) {   // x,y = bunnmidt, s = bredde
    const h = s * 0.78, c = y - h/2, o = '#F28C28', d = '#D9661A';
    let g = `<g>`;
    g += `<path d="M${x-s*0.04} ${c-h*0.48} q ${s*0.02} ${-h*0.22} ${s*0.12} ${-h*0.26} l ${s*0.03} ${h*0.07} q ${-s*0.07} ${h*0.05} ${-s*0.07} ${h*0.2}Z" fill="#4E6B2F"/>`;
    [[-0.3, 0.26], [0.3, 0.26], [-0.14, 0.3], [0.14, 0.3], [0, 0.28]].forEach(([dx, rx]) => g += `<ellipse cx="${x + dx*s}" cy="${c}" rx="${rx*s}" ry="${h/2}" fill="${o}" stroke="${d}" stroke-width="${s*0.012}"/>`);
    if (face) {
      const f = glow ? '#FFE066' : '#3B1F0E';
      g += `<path d="M${x-s*0.24} ${c-h*0.08} l ${s*0.08} ${-h*0.2} l ${s*0.08} ${h*0.2}Z M${x+s*0.08} ${c-h*0.08} l ${s*0.08} ${-h*0.2} l ${s*0.08} ${h*0.2}Z" fill="${f}"/>`;
      g += `<path d="M${x-s*0.28} ${c+h*0.06} q ${s*0.28} ${h*0.36} ${s*0.56} 0 l ${-s*0.07} ${h*0.04} l ${-s*0.05} ${-h*0.04} l ${-s*0.06} ${h*0.06} l ${-s*0.06} ${-h*0.06} l ${-s*0.06} ${h*0.06} l ${-s*0.06} ${-h*0.06} l ${-s*0.05} ${h*0.04} Z" fill="${f}"/>`;
    }
    return g + `</g>`;
  }
  function bat(x, y, s, rot, col) {
    return `<path transform="translate(${x} ${y}) rotate(${rot||0}) scale(${s/100})" fill="${col||'#1a1026'}" d="M0 -6 C4 -14 8 -14 9 -8 C14 -18 30 -22 50 -10 C40 -10 36 -4 38 4 C30 -2 24 0 20 8 C14 2 6 2 0 10 C-6 2 -14 2 -20 8 C-24 0 -30 -2 -38 4 C-36 -4 -40 -10 -50 -10 C-30 -22 -14 -18 -9 -8 C-8 -14 -4 -14 0 -6Z"/>`;
  }
  function ghost(x, y, s) {   // x,y = toppmidt
    const w = s, h = s * 1.25;
    return `<g><path d="M${x-w/2} ${y+h*0.45} C${x-w/2} ${y-h*0.05} ${x+w/2} ${y-h*0.05} ${x+w/2} ${y+h*0.45} L${x+w/2} ${y+h} q ${-w/8} ${-h*0.1} ${-w/4} 0 t ${-w/4} 0 t ${-w/4} 0 t ${-w/4} 0 Z" fill="#fff" stroke="#e6e0f0" stroke-width="${s*0.02}"/>` +
      `<ellipse cx="${x-w*0.16}" cy="${y+h*0.38}" rx="${w*0.07}" ry="${w*0.1}" fill="#2b2140"/><ellipse cx="${x+w*0.16}" cy="${y+h*0.38}" rx="${w*0.07}" ry="${w*0.1}" fill="#2b2140"/>` +
      `<ellipse cx="${x}" cy="${y+h*0.58}" rx="${w*0.08}" ry="${w*0.1}" fill="#2b2140"/></g>`;
  }
  function web(cx, cy, R, sx, sy, col, sw) {   // hjørnevev, sx/sy = 1 eller -1 (retning)
    let g = `<g fill="none" stroke="${col}" stroke-width="${sw}" stroke-linecap="round">`;
    const n = 6, angs = [];
    for (let i = 0; i <= n; i++) angs.push((Math.PI/2) * i / n);
    angs.forEach(a => g += `<path d="M${cx} ${cy} L${cx + sx*R*Math.cos(a)} ${cy + sy*R*Math.sin(a)}"/>`);
    for (let k = 1; k <= 5; k++) {
      const r = R * k / 5.4; let d = '';
      for (let i = 0; i < angs.length; i++) {
        const a = angs[i], px = cx + sx*r*Math.cos(a), py = cy + sy*r*Math.sin(a);
        if (i === 0) d += `M${px} ${py}`;
        else { const am = (angs[i-1] + a)/2, rm = r * 0.86; d += ` Q${cx + sx*rm*Math.cos(am)} ${cy + sy*rm*Math.sin(am)} ${px} ${py}`; }
      }
      g += `<path d="${d}"/>`;
    }
    return g + `</g>`;
  }
  function spider(x, y0, y, s, col) {
    return `<g stroke="${col}" fill="${col}"><path d="M${x} ${y0} V${y}" stroke-width="${s*0.04}"/>` +
      `<ellipse cx="${x}" cy="${y + s*0.3}" rx="${s*0.28}" ry="${s*0.34}" stroke="none"/><circle cx="${x}" cy="${y}" r="${s*0.17}" stroke="none"/>` +
      [-1, 1].map(k => [0.05, 0.25, 0.45, 0.62].map((t, i) => `<path d="M${x} ${y + s*t} q ${k*s*0.45} ${-s*0.25 + i*s*0.1} ${k*s*0.7} ${s*0.2 + i*s*0.08}" fill="none" stroke-width="${s*0.06}"/>`).join('')).join('') + `</g>`;
  }


  // bakgrunnsbilde som dekker hele banneret (inkl. bleed)
  function bgImage(url, iw, ih, W, H, b) {
    const href = root.BannerRender.asset(url), bw = W + 2*b, bh = H + 2*b, ar = iw / ih;
    let w = bw, h = bw / ar; if (h < bh) { h = bh; w = bh * ar; }
    return `<image href="${href}" xlink:href="${href}" x="${-b + (bw - w)/2}" y="${-b + (bh - h)/2}" width="${w}" height="${h}" preserveAspectRatio="none"/>`;
  }


  // ---- stripete pastell: hvite og fargede loddrette striper, ca. 5 cm brede på 130×40 ----
  // [id, navn, stripefarge, tekstfarge, eksempelnavn] — eksempelnavn: topp-navn SSB 2025, 6 jente (rosa/lilla/fersken/lavendel/gul/sand) + 6 gutt
  const STRIPER = [
    ['gul', 'Gul', '#F2E1A0', '#D29312', 'Ella'], ['oransje', 'Oransje', '#F5D1B0', '#D2701F', 'William'], ['fersken', 'Fersken', '#F6D7CD', '#C9654B', 'Nora'],
    ['rosa', 'Rosa', '#F4D2D9', '#CC6179', 'Emma'], ['lilla', 'Lilla', '#DFCEED', '#8858BC', 'Olivia'], ['lavendel', 'Lavendel', '#DCDCF3', '#5F5FB5', 'Sofie'],
    ['blaa', 'Lyseblå', '#CADEEE', '#4A82B6', 'Noah'], ['turkis', 'Turkis', '#C1E5E3', '#23918E', 'Jakob'], ['mint', 'Mint', '#D0EBDC', '#378A68', 'Lucas'],
    ['gronn', 'Grønn', '#DAE8C4', '#5C8A28', 'Emil'], ['salvie', 'Salvie', '#DAE1D2', '#627A50', 'Oskar'], ['sand', 'Sand', '#EBE1D1', '#97764A', 'Frida']
  ];
  function stripeDesign(c, d, ekstra) {
    const farger = Array.isArray(c) ? c : [c];
    return Object.assign({
      swatch: farger[0], font: 'playwrite', fastFont: true, max1: 24, max2: 16, l1style: { font: 'quicksand', upper: true, ls: 0.24, max: 0.21 }, l2max: 0.52,
      colors: { l1: d, l2: d },
      photo: { cx: 62, cy: 50, r: 32, ring: d },
      photoC: null,     // 'over' = sirkel i midten med buet tekst (forkastet 24.10, Rich valgte sirkel til venstre)
      box: { photo: [104, 9, -22, 79], none: [22, 9, -22, 79] },
      draw(W, H, u, b) {
        const sw = 12.5 * u; let n = Math.max(1, Math.round(W / sw)); if (n % 2 === 0) n += 1;   // oddetall: farget stripe ytterst på begge sider
        const w = W / n;
        let s = `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#ffffff"/>`;
        for (let i = 0, k = 0; i < n; i += 2, k++) {
          const x = i === 0 ? -b - 1 : i * w, ww = w + (i === 0 ? b + 1 : 0) + (i === n - 1 ? b + 1 : 0);
          s += `<rect x="${x}" y="${-b}" width="${ww}" height="${H+2*b}" fill="${farger[k % farger.length]}"/>`;
        }
        return s;
      }
    }, ekstra || {});
  }

  // ---- fargestriper: tydeligere farger enn pastell — stripe = farge 45 % mot hvitt, tekst i full farge ----
  // [id, navn, stripefarge(r), tekstfarge, eksempelnavn]
  const STERKE = [
    ['rod', 'Rød', '#F3ADAF', '#DD1A20', 'Sofie'],
    ['korall', 'Korall', '#F9BCB5', '#D9453A', 'Nora'],
    ['oransje', 'Oransje', '#F8C49F', '#D05F10', 'Oskar'],
    ['gul', 'Gul', '#FAE4A0', '#B07F00', 'Ella'],
    ['lime', 'Lime', '#CBE5A9', '#4E8A1A', 'Lucas'],
    ['gronn', 'Grønn', '#A1D6BC', '#248858', 'Emil'],
    ['turkis', 'Turkis', '#98DDDC', '#0E8584', 'Jakob'],
    ['blaa', 'Blå', '#A1C9F0', '#1A6EC2', 'Noah'],
    ['kongeblaa', 'Kongeblå', '#A4B4E6', '#2847A6', 'William'],
    ['lilla', 'Lilla', '#CCB5EA', '#7133C2', 'Olivia'],
    ['rosa', 'Rosa', '#F5B2D2', '#E61E7C', 'Emma'],
    ['regnbue', 'Regnbue', ['#F3ADAF', '#F8C49F', '#FAE4A0', '#A1D6BC', '#A1C9F0', '#CCB5EA'], '#3A3A4A', 'Frida']
  ];

  const DESIGNS = {
    egen: { name: 'Last opp eget design', own: true, font: 'fredoka', colors: {}, photo: { cx: 0, cy: 0, r: 1, ring: '#fff' }, box: { photo: [0,0,0,0], none: [0,0,0,0] }, draw() { return ''; } },
    halloween_zombie: {
      name: 'Zombie', swatch: '#0E2224', font: 'creepster', art: { iw: 1984, ih: 608 },
      colors: { l1: '#C8F169', l2: '#F2F2E6' },
      photo: { cx: 190, cy: 50, r: 28, ring: '#C8F169' },
      box: { photo: [226, 14, -22, 86], none: [160, 14, -24, 86] },
      draw(W, H, u, b) {
        return `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#0E2224"/>` +
          bgImage('https://cdn.shopify.com/s/files/1/0526/7419/9720/files/banner-halloween-zombie.png?v=1792594910', 1984, 608, W, H, b);
      }
    },
    halloween_spokelser: {
      name: 'Søte spøkelser', swatch: '#3B2463', font: 'creepster', art: { iw: 1984, ih: 608 },
      colors: { l1: '#FF9F1C', l2: '#F3E8FF' },
      photo: { cx: 130, cy: 52, r: 24, ring: '#FF9F1C' },
      box: { photo: [158, 20, -98, 80], none: [108, 20, -108, 80] },
      draw(W, H, u, b) {
        return `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#3B2463"/>` +
          bgImage('https://cdn.shopify.com/s/files/1/0526/7419/9720/files/banner-halloween-spokelser.png?v=1792593643', 1984, 608, W, H, b);
      }
    },
    rosegull_konfetti: {
      name: 'Gullkonfetti', swatch: '#FBE3E1', font: 'dancing', art: { iw: 6656, ih: 2048 },
      colors: { l1: '#A87428', l2: '#8E5A63' },
      photo: { cx: 105, cy: 50, r: 31, ring: '#C9A24B' },
      box: { photo: [145, 14, -74, 86], none: [60, 14, -60, 86] },
      draw(W, H, u, b) {
        return `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#FBE3E1"/>` +
          bgImage('https://cdn.shopify.com/s/files/1/0526/7419/9720/files/banner-rosegull-konfetti.jpg', 6656, 2048, W, H, b);
      }
    },
    rosegull_glitter: {
      name: 'Gullglitter', swatch: '#F6D5D6', font: 'dancing', art: { iw: 3302, ih: 1016 },
      colors: { l1: '#A87428', l2: '#8E5A63' },
      photo: { cx: 105, cy: 50, r: 31, ring: '#C9A24B' },
      box: { photo: [145, 14, -74, 86], none: [60, 14, -74, 86] },
      draw(W, H, u, b) {
        return `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#F6D5D6"/>` +
          bgImage('https://cdn.shopify.com/s/files/1/0526/7419/9720/files/banner-rosegull-glitter.jpg', 3302, 1016, W, H, b);
      }
    },
    halloween_natt: {
      name: 'Halloween-natt', swatch: '#2A1B3D', font: 'creepster',
      colors: { l1: '#F28C28', l2: '#FFB347' },
      photo: { cx: 84, cy: 50, r: 30, ring: '#F28C28' },
      box: { photo: [122, 12, -70, 80], none: [58, 12, -70, 80] },
      draw(W, H, u, b) {
        let s = `<defs><radialGradient id="hnSky" cx="85%" cy="20%" r="90%"><stop offset="0" stop-color="#4B2E6F"/><stop offset="1" stop-color="#1A1026"/></radialGradient></defs>`;
        s += `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="url(#hnSky)"/>`;
        const mx = W - 34*u, my = 30*u;
        s += `<circle cx="${mx}" cy="${my}" r="${24*u}" fill="#FFF3C4" opacity=".18"/><circle cx="${mx}" cy="${my}" r="${19*u}" fill="#FFF0B3"/>`;
        s += `<circle cx="${mx-6*u}" cy="${my-4*u}" r="${3*u}" fill="#F2E19A"/><circle cx="${mx+5*u}" cy="${my+6*u}" r="${4*u}" fill="#F2E19A"/><circle cx="${mx+7*u}" cy="${my-7*u}" r="${2*u}" fill="#F2E19A"/>`;
        s += bat(mx - 4*u, my + 2*u, 22*u, -8) + bat(W - 70*u, 16*u, 14*u, 10) + bat(W*0.35, 10*u, 10*u, -14, '#3a2550') + bat(W*0.55, 8*u, 8*u, 12, '#3a2550') + bat(24*u, 14*u, 12*u, 6);
        s += `<path d="M${-b} ${H+b} L${-b} ${H-10*u} Q${W*0.25} ${H-18*u} ${W*0.5} ${H-9*u} T${W+b} ${H-14*u} L${W+b} ${H+b}Z" fill="#120a1a"/>`;
        s += pumpkin(20*u, H - 3*u, 36*u, true, true) + pumpkin(48*u, H - 1*u, 24*u, true, true);
        s += pumpkin(W - 24*u, H - 2*u, 32*u, true, true);
        return s;
      }
    },
    halloween_sot: {
      name: 'Søt halloween', swatch: '#FFF4E6', font: 'fredoka',
      colors: { l1: '#7B4FA0', l2: '#F28C28' },
      photo: { cx: 80, cy: 50, r: 30, ring: '#F28C28' },
      box: { photo: [118, 12, -46, 86], none: [46, 12, -46, 86] },
      draw(W, H, u, b) {
        let s = `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#FFF4E6"/>`;
        const r = rng(31);
        for (let i = 0; i < Math.round(W/u*0.25); i++) { const x = r()*W, y = r()*H; s += `<circle cx="${x}" cy="${y}" r="${(0.6+r()*0.8)*u}" fill="${['#F9C49A','#CDB9F0','#B9E4C9'][i%3]}" opacity=".7"/>`; }
        s += ghost(16*u, 8*u, 22*u) + pumpkin(16*u, H - 6*u, 26*u, true, false);
        s += ghost(W - 18*u, 30*u, 18*u) + pumpkin(W - 22*u, H - 4*u, 22*u, true, false);
        s += bat(W - 30*u, 14*u, 12*u, 8, '#5B3A7A') + bat(36*u, 12*u, 9*u, -10, '#5B3A7A');
        return s;
      }
    },
    halloween_spindel: {
      name: 'Spindelvev', swatch: '#111111', font: 'creepster',
      colors: { l1: '#9BE15D', l2: '#F28C28' },
      photo: { cx: 60, cy: 54, r: 30, ring: '#9BE15D' },
      box: { photo: [98, 14, -40, 84], none: [40, 14, -40, 84] },
      draw(W, H, u, b) {
        let s = `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#111111"/>`;
        s += web(-b, -b, 52*u, 1, 1, '#d9d9d9', 0.45*u) + web(W + b, -b, 52*u, -1, 1, '#d9d9d9', 0.45*u);
        s += web(-b, H + b, 30*u, 1, -1, '#8a8a8a', 0.35*u) + web(W + b, H + b, 30*u, -1, -1, '#8a8a8a', 0.35*u);
        s += spider(W - 26*u, -b, 46*u, 9*u, '#8a8a8a');
        s += spider(28*u, -b, 30*u, 6*u, '#8a8a8a');
        s += `<rect x="${3*u}" y="${3*u}" width="${W-6*u}" height="${H-6*u}" fill="none" stroke="#F28C28" stroke-width="${0.4*u}" stroke-dasharray="${2*u} ${1.5*u}"/>`;
        return s;
      }
    },
    botanisk: {
      name: 'Botanisk', swatch: '#FBF8F3', font: 'playfair', img: 'br-floral.png', draft: true,
      colors: { l1: '#8A9A7B', l2: '#B08D57' },
      photo: { cx: 84, cy: 50, r: 32, ring: '#C9A96E' },
      box: { photo: [124, 14, -52, 86], none: [52, 14, -52, 86] },
      draw(W, H, u, b) {
        const h = H + 2*b, w = h * 0.665, href = root.BannerRender.asset('br-floral.png');
        return `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#FBF8F3"/>` +
          `<image href="${href}" xlink:href="${href}" x="${-b}" y="${-b}" width="${w}" height="${h}" preserveAspectRatio="xMinYMid meet"/>` +
          `<g transform="translate(${W} 0) scale(-1 1)"><image href="${href}" xlink:href="${href}" x="${-b}" y="${-b}" width="${w}" height="${h}" preserveAspectRatio="xMinYMid meet"/></g>`;
      }
    },
    pastell: {
      name: 'Pastell', swatch: '#F9DDE3', font: 'playfair',
      colors: { l1: '#B8893A', l2: '#B8893A' },
      photo: { cx: 47, cy: 50, r: 34, ring: '#C9A24B' },
      box: { photo: [92, 14, -14, 86], none: [14, 14, -14, 86] },
      draw(W, H, u, b) {
        return `<defs><pattern id="brStripe" width="${6*u}" height="${6*u}" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="${3*u}" height="${6*u}" fill="#fff" opacity=".22"/></pattern></defs>` +
          `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#F9DDE3"/>` +
          `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="url(#brStripe)"/>` +
          `<rect x="${5*u}" y="${5*u}" width="${W-10*u}" height="${H-10*u}" fill="none" stroke="#C9A24B" stroke-width="${1.6*u}" stroke-dasharray="0 ${3.2*u}" stroke-linecap="round"/>`;
      }
    },
    ballonger: {
      name: 'Ballonger', swatch: '#FDE28A', font: 'fredoka',
      colors: { l1: '#E0577A', l2: '#3A3A5A' },
      photo: { cx: 74, cy: 50, r: 32, ring: '#F7B2C1' },
      box: { photo: [112, 12, -42, 88], none: [42, 12, -42, 88] },
      draw(W, H, u, b) {
        const C = ['#F7B2C1', '#A7D8F0', '#FDE28A', '#B9E4C9', '#CDB9F0', '#F9C49A'];
        let s = `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#FFFDF8"/>`;
        const left = [[10, 26, 0], [24, 18, 1], [17, 46, 2], [5, 58, 3], [28, 40, 4]];
        left.forEach(([x, y, c]) => s += balloon(x*u, y*u, 9*u, 11*u, C[c], u));
        left.forEach(([x, y, c]) => s += balloon(W - x*u, y*u, 9*u, 11*u, C[(c+3)%6], u));
        return s;
      }
    },
    gull: {
      name: 'Gull & natt', swatch: '#1F2440', font: 'playfair',
      colors: { l1: '#E8C877', l2: '#F3D98B' },
      photo: { cx: 47, cy: 50, r: 34, ring: '#D9B45A' },
      box: { photo: [92, 16, -12, 84], none: [14, 16, -14, 84] },
      draw(W, H, u, b) {
        let s = `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#1F2440"/>`;
        const r = rng(7), n = Math.round(W / u * 0.9);
        for (let i = 0; i < n; i++) {
          const x = -b + r() * (W + 2*b);
          const band = r() < 0.5 ? r() * 14 : 86 + r() * 14;
          const y = band * u + (r() - .5) * 6 * u;
          const k = r();
          if (k < .55) s += `<circle cx="${x}" cy="${y}" r="${(0.5 + r()*1.1)*u}" fill="#D9B45A" opacity="${.5 + r()*.5}"/>`;
          else if (k < .85) s += `<rect x="${x}" y="${y}" width="${2.4*u}" height="${0.9*u}" fill="#E8C877" transform="rotate(${r()*180} ${x} ${y})"/>`;
          else { const z = (1.2 + r()*1.5) * u; s += `<path d="M${x} ${y-z} L${x+z*.3} ${y-z*.3} L${x+z} ${y} L${x+z*.3} ${y+z*.3} L${x} ${y+z} L${x-z*.3} ${y+z*.3} L${x-z} ${y} L${x-z*.3} ${y-z*.3}Z" fill="#F3D98B"/>`; }
        }
        s += `<rect x="${4*u}" y="${4*u}" width="${W-8*u}" height="${H-8*u}" fill="none" stroke="#D9B45A" stroke-width="${0.5*u}"/>`;
        return s;
      }
    },
    regnbue: {
      name: 'Regnbue', swatch: '#EAF6FB', font: 'fredoka',
      colors: { l1: '#F2994A', l2: '#3B4A6B' },
      photo: { cx: 47, cy: 50, r: 34, ring: '#ffffff' },
      box: { photo: [92, 12, -90, 88], none: [14, 12, -90, 88] },
      draw(W, H, u, b) {
        const C = ['#F28B82', '#F9C49A', '#FDE28A', '#B9E4C9', '#A7D8F0', '#CDB9F0'];
        let s = `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#EAF6FB"/>`;
        const cx = W - 24*u, cy = H + b;
        C.forEach((c, i) => { const rr = (62 - i*7.5) * u; s += `<path d="M${cx-rr} ${cy} A ${rr} ${rr} 0 0 1 ${cx+rr} ${cy}" fill="none" stroke="${c}" stroke-width="${7.6*u}"/>`; });
        const cloud = (x, y, k) => `<g fill="#fff"><circle cx="${x}" cy="${y}" r="${7*k*u}"/><circle cx="${x+8*k*u}" cy="${y-4*k*u}" r="${9*k*u}"/><circle cx="${x+17*k*u}" cy="${y}" r="${7*k*u}"/><rect x="${x}" y="${y-1*k*u}" width="${17*k*u}" height="${8*k*u}"/></g>`;
        s += cloud(W - 60*u, H - 10*u, 1) + cloud(W - 14*u, H - 4*u, 0.9) + cloud(W - 50*u, 18*u, 0.6);
        return s;
      }
    }
  };
  STRIPER.forEach(([id, name, c, d, ex]) => DESIGNS['stripe_' + id] = Object.assign(stripeDesign(c, d), { name, ex }));
  STERKE.forEach(([id, name, c, d, ex]) => DESIGNS['sterk_' + id] = Object.assign(stripeDesign(c, d, { l1style: { font: 'quicksand', upper: true, ls: 0.22, max: 0.21, weight: 700 }, l2stroke: 0.035 }), { name, ex }));

  // måler tekstbredde i em ved hjelp av canvas (krever at fonten er lastet)
  let _ctx;
  function emWidth(text, font, weight) {
    const f = FONTS[font];
    _ctx = _ctx || document.createElement('canvas').getContext('2d');
    _ctx.font = `${weight || f.weight} 100px ${f.css}`;
    return _ctx.measureText(text).width / 100;
  }

  /* opts: { W, H, design, font, l1, l2, photo: {href, zoom, ox, oy, iw, ih} | null,
             bleed (mm, default 0), marks (bool), order (str) } */
  function marks(opts, W, H, b) {
    let s = '';
    // trykkmerker: maljer + skjæremerker + ordreinfo (utenfor kuttkanten)
    if (opts.marks) {
      const g = 25; // maljeplassering 25 mm inn fra kant
      const xs = W > 1500 ? [g, W/2, W - g] : [g, W - g];   // hjørner, + midt på over 150 cm
      if (opts.maljer !== false) [g, H - g].forEach(yy => xs.forEach(xx => {
        s += `<circle cx="${xx}" cy="${yy}" r="1.5" fill="none" stroke="#888" stroke-width="0.25"/><path d="M${xx-2.5} ${yy}H${xx+2.5}M${xx} ${yy-2.5}V${yy+2.5}" stroke="#888" stroke-width="0.25"/>`;
      }));
      const k = 'stroke="#000" stroke-width="0.25"';
      [[0, 0, -1, -1], [W, 0, 1, -1], [0, H, -1, 1], [W, H, 1, 1]].forEach(([x, y, dx, dy]) => {
        s += `<path d="M${x + dx*(b+2)} ${y}H${x + dx*(b+10)}M${x} ${y + dy*(b+2)}V${y + dy*(b+10)}" ${k}/>`;
      });
      if (opts.order) s += `<text x="${-b}" y="${-b-4}" font-family="Helvetica,Arial,sans-serif" font-size="4" fill="#000">${esc(opts.order)}</text>`;
    }
    return s;
  }

  // Plassering av bilde-sirkel og tekstfelt. Design med fast kunst (art) er tegnet for 130×40 (13:4);
  // ved andre formater følger sirkel og tekstfelt kunsten slik den skaleres og beskjæres (cover).
  // sentrert bilde-sirkel med buet tekst (stripedesign): faste mål i enheter av H/100
  const PHOTOC = { over: { cy: 40, r: 24 } };
  function geom(D, W, H) {
    if (D.photoC) { const P0 = PHOTOC[D.photoC]; return { photo: Object.assign({}, D.photo, { cx: W / (H / 100) / 2, cy: P0.cy, r: P0.r }), box: D.box }; }
    if (!D.art) return { photo: D.photo, box: D.box };
    const Wa = W / (H / 100), Wr = 325, ar = D.art.iw / D.art.ih;
    const cov = (Wb) => { let w = Wb, h = Wb / ar; if (h < 100) { h = 100; w = 100 * ar; } return { x: (Wb - w) / 2, y: (100 - h) / 2, w, h }; };
    const r0 = cov(Wr), r1 = cov(Wa), k = r1.w / r0.w;
    const mx = X => r1.x + (X - r0.x) / r0.w * r1.w, my = Y => r1.y + (Y - r0.y) / r0.h * r1.h;
    const cl = (v, a, b) => Math.max(a, Math.min(b, v));
    const bx = b => { const X0 = cl(mx(b[0]), 2, Wa - 2), X1 = cl(mx(Wr + b[2]), 2, Wa - 2); return [X0, cl(my(b[1]), 2, 98), X1 - Wa, cl(my(b[3]), 2, 98)]; };
    const r = Math.min(D.photo.r * k, 46);
    return { photo: Object.assign({}, D.photo, { cx: mx(D.photo.cx), cy: cl(my(D.photo.cy), r + 3, 97 - r), r }),
             box: { photo: bx(D.box.photo), none: bx(D.box.none) } };
  }

  let _n = 0;
  function render(opts) {
    const id = 'br' + (++_n);
    const D = DESIGNS[opts.design] || DESIGNS.pastell;
    const W = opts.W, H = opts.H, u = H / 100, b = opts.bleed || 0;
    const font = opts.font || D.font, F = FONTS[font];
    const M = opts.marks ? 12 : 0;              // marg for skjæremerker utenfor bleed
    const vx = -b - M, vy = -b - M, vw = W + 2*(b+M), vh = H + 2*(b+M);
    let s = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="${vx} ${vy} ${vw} ${vh}" width="${vw}mm" height="${vh}mm">`;
    s += `<defs><clipPath id="${id}T"><rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}"/></clipPath></defs><g clip-path="url(#${id}T)">`;
    if (D.own) {
      // kundens egen ferdige fil: dekker hele banneret (inkl. bleed), kan zoomes/flyttes
      s += `<rect x="${-b}" y="${-b}" width="${W+2*b}" height="${H+2*b}" fill="#f2f2f2"/>`;
      const Fi = opts.full;
      if (Fi && Fi.href) {
        const bw = W + 2*b, bh = H + 2*b, ar = Fi.iw / Fi.ih;
        let w = bw, h = bw / ar; if (h < bh) { h = bh; w = bh * ar; }
        w *= (Fi.zoom || 1); h *= (Fi.zoom || 1);
        const x = -b + (bw - w)/2 + (Fi.ox || 0) * bw, y = -b + (bh - h)/2 + (Fi.oy || 0) * bh;
        s += `<image href="${esc(Fi.href)}" xlink:href="${esc(Fi.href)}" x="${x}" y="${y}" width="${w}" height="${h}" preserveAspectRatio="none"/>`;
      } else {
        s += `<text x="${W/2}" y="${H/2}" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" font-size="${H*0.08}" fill="#999">Last opp din ferdige fil</text>`;
      }
      if (opts.guides) s += `<rect x="${30}" y="${30}" width="${W-60}" height="${H-60}" fill="none" stroke="#e53e3e" stroke-width="${H*0.004}" stroke-dasharray="${H*0.02} ${H*0.015}" opacity=".8"/>`;
      s += `</g>`;
      return s + marks(opts, W, H, b) + `</svg>`;
    }
    s += D.draw(W, H, u, b);
    const G = geom(D, W, H);

    // bilde i sirkel
    const P = opts.photo && opts.photo.href ? opts.photo : null;
    if (P) {
      const cx = G.photo.cx * u, cy = G.photo.cy * u, r = G.photo.r * u;
      const z = P.zoom || 1, ar = (P.iw && P.ih) ? P.iw / P.ih : 1;
      // dekk sirkelen (cover), så zoom og flytt (ox/oy i andeler av diameter)
      let w = 2*r, h = 2*r; if (ar > 1) w = h * ar; else h = w / ar;
      w *= z; h *= z;
      const x = cx - w/2 + (P.ox || 0) * 2*r, y = cy - h/2 + (P.oy || 0) * 2*r;
      s += `<clipPath id="${id}P"><circle cx="${cx}" cy="${cy}" r="${r}"/></clipPath>`;
      s += `<circle cx="${cx}" cy="${cy}" r="${r + 2.2*u}" fill="${G.photo.ring}"/><circle cx="${cx}" cy="${cy}" r="${r + 0.8*u}" fill="#fff"/>`;
      s += `<g clip-path="url(#${id}P)"><rect x="${cx-r}" y="${cy-r}" width="${2*r}" height="${2*r}" fill="#eee"/><image href="${esc(P.href)}" xlink:href="${esc(P.href)}" x="${x}" y="${y}" width="${w}" height="${h}" preserveAspectRatio="none"/></g>`;
    }

    // buet tekst rundt sentrert bilde: linje 1 i slak bue over sirkelen, linje 2 i slak bue under («smil»).
    // Buene har større radius enn sirkelen (flatere), og avstanden til sirkelen øker mot endene.
    if (P && D.photoC) {
      const cx = G.photo.cx * u, cy = G.photo.cy * u, rc = (G.photo.r + 2.2) * u;   // ytterkant av ringen
      const S1 = D.l1style || {}, t1 = (opts.l1 || '').trim(), t2 = (opts.l2 || '').trim();
      let k = 0;
      // top: grunnlinje over sirkelen, bokstavene peker opp; ellers grunnlinje under, bokstavene peker mot sirkelen
      const bue = (t, f, w, ls, sk, c, top, fsMax, luft, asc) => {
        const Fl = FONTS[f], ew = emWidth(t, f, w) + ls * t.length + (sk || 0);
        let fs = fsMax, R = 0, d0 = 0;
        for (let i = 0; i < 6; i++) {
          d0 = rc + luft * u + (top ? 0 : asc * fs);       // avstand sirkelsenter → grunnlinjens midtpunkt
          R = d0 * 1.6;                                      // slakere bue enn sirkelen
          fs = Math.min(fsMax, ew > 0 ? R * 2.0 / ew : fsMax); // maks ca. 115° bue
        }
        const yb = top ? cy - d0 : cy + d0, ac = top ? yb + R : yb - R, lsu = ls * fs, pid = id + 'arc' + (++k);
        s += `<path id="${pid}" d="M${cx - R} ${ac}A${R} ${R} 0 0 ${top ? 1 : 0} ${cx + R} ${ac}" fill="none"/>`;
        const strek = sk ? ` stroke="${c}" stroke-width="${fs * sk}" stroke-linejoin="round"` : '';
        s += `<text font-family="${Fl.css}" font-weight="${w || Fl.weight}" font-size="${fs}"${lsu ? ` letter-spacing="${lsu}"` : ''}${strek} fill="${c}">` +
             `<textPath href="#${pid}" xlink:href="#${pid}" startOffset="50%" text-anchor="middle">${esc(t)}</textPath></text>`;
      };
      if (t1) bue(S1.upper ? t1.toLocaleUpperCase('nb') : t1, S1.font || font, S1.weight, S1.ls || 0, 0, D.colors.l1, true, 8.5 * u, 2.2, 0);
      if (t2) bue(t2, font, undefined, 0, D.l2stroke || 0, D.colors.l2, false, 18 * u, 1.6, 0.92);
      s += `</g>` + marks(opts, W, H, b);
      return s + `</svg>`;
    }

    // tekst (linje 1 kan ha egen stil i designet: egen font, store bokstaver, sperret)
    const bx = G.box[P ? 'photo' : 'none'];
    const x0 = bx[0]*u, x1 = W + bx[2]*u, y0 = bx[1]*u, y1 = bx[3]*u, bh = y1 - y0, bw = x1 - x0;
    const S1 = D.l1style || {}, t1 = (opts.l1 || '').trim(), t2 = (opts.l2 || '').trim();
    const lines = [];
    if (t1) lines.push({ t: S1.upper ? t1.toLocaleUpperCase('nb') : t1, f: S1.font || font, w: S1.weight, ls: S1.ls || 0, max: t2 ? (S1.max || 0.26) : 0.5, c: D.colors.l1 });
    if (t2) lines.push({ t: t2, f: font, ls: 0, sk: D.l2stroke || 0, max: t1 ? (D.l2max || 0.42) : 0.5, c: D.colors.l2 });
    lines.forEach(l => { const ew = emWidth(l.t, l.f, l.w) + l.ls * l.t.length + (l.sk || 0); l.fs = Math.min(l.max * bh, ew > 0 ? bw / ew : 1e9); });
    const gap = 0.32 * bh * (lines.length > 1 ? 1 : 0);
    const caps = lines.map(l => FONTS[l.f].cap * l.fs);
    const total = caps.reduce((a, c) => a + c, 0) + gap * (lines.length - 1);
    let y = y0 + (bh - total) / 2;
    lines.forEach((l, i) => {
      y += caps[i];
      const Fl = FONTS[l.f], lsu = l.ls * l.fs;
      const halo = D.halo ? ` stroke="${D.halo}" stroke-width="${l.fs * 0.11}" stroke-linejoin="round" paint-order="stroke"` : l.sk ? ` stroke="${l.c}" stroke-width="${l.fs * l.sk}" stroke-linejoin="round"` : '';
      s += `<text x="${(x0+x1)/2 + lsu/2}" y="${y}" text-anchor="middle" font-family="${Fl.css}" font-weight="${l.w || Fl.weight}" font-size="${l.fs}"${lsu ? ` letter-spacing="${lsu}"` : ''}${halo} fill="${l.c}">${esc(l.t)}</text>`;
      y += gap;
    });
    s += `</g>`;

    s += marks(opts, W, H, b);
    return s + `</svg>`;
  }

  root.BannerRender = { FONTS, DESIGNS, render, geom, asset: n => n };
})(typeof window !== 'undefined' ? window : globalThis);
